import classnames from "classnames";
import React, { memo, ReactElement } from "react";

import styles from "./Overlay.scss";
import { withStyles } from "@core-ui/helpers/WithStyles";

export interface OverlayProps {
    visible?: boolean;
    onClick?: () => void;
    className?: string;
    dataTestId?: string;
}

function Overlay(props: OverlayProps): ReactElement {
    const overlayClass = classnames(
        {
            [styles.overlay]: true,
            [styles.overlayVisible]: props.visible ?? true,
        },
        props.className,
    );

    const handleClick = (): void => {
        typeof props.onClick === "function" && props.onClick();
    };

    return <div className={overlayClass} onClick={handleClick} data-testid={props.dataTestId} />;
}

export default memo(withStyles(Overlay, styles));
